import React, { useEffect, useState } from "react";
import LayoutFrontend from "./inc/layout-frontend";
import { Link, useParams } from "react-router-dom";
import { myroutes } from "../routes/webroute";
import PeriodiquesService from "../services/PeriodiquesService";
import PublicationsService from "../services/PublicationsService";
import { app_url } from "../services/AuthService";
import { useDispatch } from "react-redux";
import { addToCart } from "../app/providers/panierSlice";

export default function Recherche(props) {

  const [publications, setPublications] = useState([]);

  const [periodiques, setPeriodiques] = useState([]);

  const { searchTerm } = useParams();

  const [searchResults, setSearchResults] = useState([]);

  const dispatch = useDispatch();


  useEffect(() => {
    // Fonction pour rechercher les publications
    const fetchSearchResults = async () => {
      try {
        // Décoder pour  le searchTerm et le stocker dans une variable ici
        const decodedSearchTerm = decodeURIComponent(searchTerm);

       // Service pour récupérer les résultats de recherche
        const response = await PublicationsService.rechercherParTitre(decodedSearchTerm);
        setSearchResults(response.data.publications);
      } catch (error) {
        console.log(error);
      }
    };

    //  Fonction pour récupérer les résultats de recherche
    fetchSearchResults();
  }, [searchTerm]);

  const ajouterPanier = async (publication) => {
    try {
      let price = publication.montant_publication; // Valeur par défaut
  
      if (publication.typepublication_id === 2 && publication.periodique_id) {
        // Récupérer les informations du périodique
        const periodique = periodiques.find((periodique) => periodique.id === publication.periodique_id);
  
        if (periodique) {
          price = periodique.montant_periodique; // Utiliser montant_periodique pour typepublication_id = 2
        }
      }
  
      let set_publication = {
        id: publication.id,
        name: publication.titre,
        price: price,
        laune: publication.laune_path,
      };
      let item = { ...set_publication, quantity: 1 };
      dispatch(addToCart(item));
      // Voir le contenu du panier
      //console.log(contentPanier);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <LayoutFrontend>
      {/** Navbar Start */}
      <div className="container-fluid position-relative p-0">
        <div className="container-fluid bg-primary py-5 bg-header" style={{ marginBottom: "90px" }}>
          <div className="row py-5">
            <div className="col-12 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-4 text-white animated zoomIn">Recherche</h1>
              <Link className="h5" style={{ color: "goldenrod" }} to={myroutes.homepage}>
                Accueil
              </Link>
              <i className="far fa-circle text-white px-2"></i>
              <Link className="h5 text-white">
                Résultat(s) de la recherche
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/** Navbar End */}

      <div className="container-fluid py-3 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-3">
    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto">
      <h5 className="fw-bold text-primary text-uppercase"></h5>
      <h1 className="text-legend mb-3 ">Résultats de la recherche</h1>
    </div>
    <div className="row g-5 mt-0">
      {searchResults.map((publication, index) => (
        <div key={index} className="col-lg-3 wow slideInUp" data-wow-delay="0.3s">
          <div className="team-item bg-light rounded overflow-hidden">
            <div className="team-img position-relative overflow-hidden">
              <img
                className="img-fluid w-100"
                alt="image indisponible"
                style={{ height: "380px" }}
                src={app_url + "/storage/laune/" + publication.laune_path}
              />
              <div className="team-social">
                <Link
                  className="btn btn-lg btn-primary btn-lg-square rounded"
                  onClick={() => ajouterPanier(publication)}
                >
                  <i className="fas fa-shopping-cart"></i>
                </Link>
                <a className="btn btn-lg btn-primary btn-lg-square rounded" href="">
                  <i className="fa fa-heart"></i>
                </a>
                <a
                  className="btn btn-lg btn-primary btn-lg-square rounded"
                  href={`/details_publications/${publication.id}`}
                  title="Voir plus d'informations"
                >
                  <i className="fa fa-eye"></i>
                </a>
                <a className="btn btn-lg btn-primary btn-lg-square rounded" href="">
                  <i className="fa fa-random"></i>
                </a>
              </div>
            </div>
            <div className="text-card">
              <p className="text-books" style={{ lineHeight: "1.5rem" }}>
                {publication.titre.substring(0, 25)}...
              </p>
            </div>
            <div
              className="text-center py-2"
              style={{ color: "black", fontWeight: "bold", backgroundColor: "rgb(237, 245, 251)" }}
            >
              {publication.typepublication_id === 2 && Array.isArray(periodiques) ? (
                // Informations spécifiques aux périodiques
                <p className="text-uppercase m-0">
                  {periodiques.find((p) => p.id === publication.periodique_id)?.montant_periodique.toLocaleString()} F CFA
                </p>
              ) : (
                // Informations générales des publications
                <p className="text-uppercase m-0">{publication.montant_publication?.toLocaleString()} F CFA</p>
              )}
            </div>
          </div>
        </div>
      ))}

      {searchResults.length === 0 && (
        <div className="col-12 text-center">
          <p>Désolée, Aucun résultat ne correspond à votre recherche.</p>
        </div>
      )}
    </div>
  </div>
</div>
     
</LayoutFrontend>
  );
}
